import i18next from 'i18next'
import XHR from 'i18next-xhr-backend'
import { reactI18nextModule, TranslationFunction } from 'react-i18next'

import { IS_TEST } from '../../environment'

export const NS = 'translation'
export const DEFAULT_LANG_KEY = 'en-US' // we dont have support for changing  language, so every is "default" :(
const FALLBACK_LANG = IS_TEST ? 'cimode' : DEFAULT_LANG_KEY

const defaultOptions: i18next.InitOptions = {
  fallbackLng: FALLBACK_LANG,
  lng: 'en-US',
  load: 'currentOnly', // load only en-US language (we can load only 1 language in our app, so all translations are stored under en-US even if they are czech or other than en-US)
  defaultNS: NS,
  debug: IS_TEST ? false : true,
  nonExplicitWhitelist: true,
  keySeparator: false,
  interpolation: {
    escapeValue: false, // React already does escaping
  },

  react: {
    wait: true,
    nsMode: 'default',
  },
}

export const createI18n = (options: i18next.InitOptions = {}) => {
  const i18nextConfig = i18next
    .use(XHR)
    .use(reactI18nextModule)
    .init({ ...defaultOptions, ...options }, (err: Error, t: TranslationFunction) => {
      if (!options.debug) {
        return
      }
      if (err) {
        // tslint:disable-next-line:no-console
        console.warn('I18N was NOT initialized!')
      } else {
        // tslint:disable-next-line:no-console
        console.log('I18N initialized success!', { t })
      }
    })

  if (!IS_TEST) {
    // i18nextConfig
    // .use(Backend)
    // .use(LanguageDetector)
  }

  return i18nextConfig
}



// WEBPACK FOOTER //
// ./src/app/core/i18n.config.ts